import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import BrandMark from '../../nurturer-marketing/components/BrandMark';
import { logout } from 'src/redux/actions/auth.action';
import { getPlatformNav } from '../config/nav';
import PlatformAvatar from './PlatformAvatar';
import PlatformIcon from './PlatformIcon';

function PlatformSidebar({ activeId, touchesBadge, pipelineWarmth = {} }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.login);
  const enabledProducts = useSelector(
    (state) => state.company?.company?.enabledProducts || []
  );
  const navItems = getPlatformNav(enabledProducts);

  const displayName = user?.name || 'Nurturer User';
  const displayRole = user?.email || 'Sales professional';

  const handleLogout = () => {
    dispatch(logout(history));
  };

  const warmthTotal = pipelineWarmth.total ?? 0;
  const warmthTouched = pipelineWarmth.touched ?? 0;
  const warmthPercent = pipelineWarmth.percent ?? 0;

  return (
    <aside className="platform-sidebar">
      <div className="platform-brand">
        <BrandMark size={38} />
        <div className="platform-brand-text">
          <div className="platform-brand-name">Nurturer</div>
          <div className="platform-brand-eyebrow">Lead nurture</div>
        </div>
      </div>

      <div className="platform-nav-label">Workspace</div>
      <nav className="platform-nav">
        {navItems.map((item) => {
          const isActive = item.id === activeId;
          const badge = item.id === 'touches' && touchesBadge > 0 ? touchesBadge : null;

          return (
            <button
              key={item.id}
              type="button"
              className={`platform-nav-item ${isActive ? 'active' : ''}`}
              onClick={() => history.push(item.path)}
            >
              <PlatformIcon name={item.icon} size={19} stroke={isActive ? 2.2 : 2} />
              <span>{item.label}</span>
              {badge != null && <span className="platform-nav-badge">{badge}</span>}
            </button>
          );
        })}
      </nav>

      <div className="platform-sidebar-foot">
        <div className="platform-warmth">
          <div className="platform-warmth-head">
            <span className="platform-warmth-title">Pipeline warmth</span>
            <span className="platform-warmth-value">{warmthPercent}%</span>
          </div>
          <div className="platform-warmth-bar">
            <div className="platform-warmth-fill" style={{ width: `${warmthPercent}%` }} />
          </div>
          <div className="platform-warmth-caption">
            {warmthTotal === 0
              ? 'No contacts in your nurture rotation yet.'
              : `${warmthTouched} of ${warmthTotal} contacts touched in the last cycle.`}
          </div>
        </div>

        <div className="platform-user">
          <PlatformAvatar name={displayName} size={34} />
          <div className="platform-user-meta">
            <div className="platform-user-name">{displayName}</div>
            <div className="platform-user-role">{displayRole}</div>
          </div>
          <button type="button" className="platform-logout" onClick={handleLogout} aria-label="Log out">
            <PlatformIcon name="logout" size={17} />
          </button>
        </div>
      </div>
    </aside>
  );
}

export default PlatformSidebar;
